import React from 'react';
import { useRedirect, ReferenceArrayInput, DateField, DateInput, SelectInput, List, Filter, Datagrid, TextField, 
    NumberField, AutocompleteArrayInput } from 'react-admin';


const LogField = props => {
    return (
        <div style={{ overflowY: 'auto', maxHeight: '200px', maxWidth: "1000px" }} >
            <TextField textAlign='left' source="update_string" label="Update Value"{...props} />
        </div >
    )
};
const LogFilter = (props) => (
    <Filter {...props}>
        <SelectInput label="" source="collection" alwaysOn resettable
            choices={[
                { id: 'publisher', name: 'Publishers' },
                { id: 'site', name: 'Sites' },
                { id: 'placement', name: 'Placements' },
                { id: 'campaign', name: 'Campaigns' },
                { id: 'bidder', name: 'Bidders' },
                { id: 'user', name: 'Users' },
            ]} />
        <ReferenceArrayInput alwaysOn resettable
            source="publisher_id" 
            reference="publishers"
            basePath="publishers"
            perPage={15} 
            sort={{ field: 'name', order: 'ASC' }}
            filterToQuery={searchText => ({ search_name: searchText })}
            allowEmpty
            >
            <AutocompleteArrayInput label="Publishers" optionText="name" optionValue="code"/>
        </ReferenceArrayInput>
        <ReferenceArrayInput alwaysOn resettable
            source="site_id" 
            reference="sites"
            basePath="sites"
            perPage={15} 
            sort={{ field: 'name', order: 'ASC' }}
            filterToQuery={searchText => ({ search_name: searchText })}
            allowEmpty
            >
            <AutocompleteArrayInput label="Sites" optionValue="code" optionText="adunit_path" />
        </ReferenceArrayInput>
        <ReferenceArrayInput alwaysOn resettable
            source="update_value.updated_id" 
            reference="users"
            basePath="users"
            perPage={15} 
            sort={{ field: 'name', order: 'ASC' }}
            filterToQuery={searchText => ({ search_name: searchText })}
            >
            <AutocompleteArrayInput label="User" optionValue="code" optionText={(u => u ? `${u.name} - ${u.username} - ${u.role}` : '')}/>
        </ReferenceArrayInput>
        
        <DateInput label="Start Date" source="start_date" alwaysOn />
        <DateInput label="End Date" source="end_date" alwaysOn />

    </Filter>
);
export const LogsList = (props) => {
    var path = 'bidders'
    const redirect = useRedirect();

    return (
        <List {...props} filters={<LogFilter />} perPage={50} bulkActionButtons={false} title="Logbook" exporter={false}>
            <Datagrid rowClick={(id, basePath, record) => {
                if (record.collection === 'users') {
                    redirect('/users/' + record['doc_code'])
                    return
                }
                path = ('/' + record.collection + 's/' + record['doc_code'])
                redirect(path)
            }}>
                <NumberField source="code" label="ID" />
                <TextField source="collection" label="Collection" />
                <DateField source="created_at" label="Time Processed" showTime style={{ whiteSpace: 'nowrap' }} />

                <LogField />
                <TextField source="doc_code" label="Document Code" />

                <TextField source="update_value.updated_name" label="User Name" />
                <TextField source="update_value.updated_role" label="User Role" />

            </Datagrid>
        </List >
    )
};
